import React, { useEffect, useState } from 'react'
import { Container, Image } from 'react-bootstrap';
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw";
import { useParams } from 'react-router-dom';
import articleData from "../data.json"


const posts = articleData.data;

const Article = () => {
  const { id } = useParams();
  const post = posts.find((post) => post.id === Number(id));
  console.log(post);

  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(`/contents/works/${post.content}`)
      .then((res) => res.text())
      .then((text) => setContent(text));
  // eslint-disable-next-line
  }, []);

  return (
    <Container className='mt-5 mb-5 w-75'>
      <Image src={post.img} width="70%" className='mb-5'></Image>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        children={content} className="text-left" />
    </Container>
  )
}

export default Article